
export const locationViews = self => ({
  set(key, value) {
    self[key] = value
  }
})